import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Card, CardContent } from '../ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminMetricsTab = ({ metrics, fetchMetrics, authHeaders, showMsg, loading, setLoading }) => {
  const [form, setForm] = useState({ value: '', label: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/metrics`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      if (res.ok) { setForm({ value: '', label: '' }); fetchMetrics(); showMsg('Metric added!'); }
      else showMsg('Failed to add metric', 'error');
    } catch { showMsg('Error adding metric', 'error'); }
    setLoading(false);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="lg:col-span-1 shadow-sm border border-[#E8DFD3] h-fit bg-white">
        <CardContent className="p-5">
          <h3 className="font-bold text-[#2C1810] mb-4 flex items-center gap-2">
            <Plus size={16} className="text-[#5C7A3A]" /> Add Metric
          </h3>
          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="text-xs font-medium text-[#7a6555] mb-1 block">Value</label>
              <Input data-testid="metric-value-input" placeholder="e.g., 2,500+ or 15+" value={form.value} onChange={e => setForm(f => ({ ...f, value: e.target.value }))} required />
            </div>
            <div>
              <label className="text-xs font-medium text-[#7a6555] mb-1 block">Label</label>
              <Input data-testid="metric-label-input" placeholder="e.g., Meals Served Daily" value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))} required />
            </div>
            <Button type="submit" data-testid="add-metric-btn" disabled={loading} className="w-full bg-[#5C7A3A] hover:bg-[#4a6530] text-white cursor-pointer">{loading ? 'Adding...' : 'Add Metric'}</Button>
          </form>
        </CardContent>
      </Card>
      <div className="lg:col-span-2 space-y-3">
        {metrics.length === 0
          ? <div className="text-center py-12 text-[#7a6555]" data-testid="no-metrics">No metrics yet. Add trust counters shown on homepage.</div>
          : metrics.map(m => (
            <Card key={m.id} className="shadow-sm border border-[#E8DFD3] bg-white" data-testid={`metric-item-${m.id}`}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="w-14 h-14 rounded-xl bg-[#C4844A]/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-[#C4844A] text-center leading-tight">{m.value}</span>
                </div>
                <div className="flex-1"><p className="font-bold text-[#2C1810]">{m.label}</p></div>
                <Button onClick={async () => {
                  setLoading(true);
                  try {
                    await fetch(`${API}/api/admin/metrics/${m.id}`, { method: 'DELETE', headers: authHeaders() });
                    fetchMetrics(); showMsg('Metric deleted');
                  } catch { showMsg('Delete failed', 'error'); }
                  setLoading(false);
                }} variant="ghost" size="sm" data-testid={`delete-metric-${m.id}`} className="text-red-500 hover:bg-red-50 cursor-pointer"><Trash2 size={16} /></Button>
              </CardContent>
            </Card>
          ))
        }
      </div>
    </div>
  );
};

export default AdminMetricsTab;
